import { useEffect } from 'react';

/**
 * Hook for marking notifications as read by conversation ID
 * Automatically marks notifications as read when conversationId changes
 * @param {string} conversationId - Conversation ID
 */
const useMarkNotificationsReadByConversation = (conversationId) => {
  useEffect(() => {
    const markNotificationsAsRead = async () => {
      if (!conversationId) {
        return;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/notifications/mark-read-by-conversation/${conversationId}`,
          {
            method: 'PUT',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({}), // Send empty JSON object
          }
        );

        if (response.ok) {
          const data = await response.json();
          // Dispatch custom event to trigger notification refresh in all consumers
          window.dispatchEvent(new CustomEvent('notificationsUpdated'));
        }
      } catch (error) {
        // Error marking notifications as read
      }
    };

    markNotificationsAsRead();
  }, [conversationId]);
};

export default useMarkNotificationsReadByConversation;

